import React from 'react';
import Table from "src/componets/Table";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ColumnsType } from "antd/es/table";
import { ButtonEdit } from "src/componets/Buttons";
import { setEditId, BundleInterface } from "src/store/watcher/bundlesSlice";
import { EntityId } from "@reduxjs/toolkit";
import usePermissions from "src/hooks/usePermissions";
import { formattedDate } from "src/helpers/DateHelpers";
import OptionalLink from "src/componets/OptionalLink";
import Pagination from "src/componets/Pagination";

import {Avatar, Space, Tag} from "antd";
import { AndroidOutlined, AppleOutlined } from "@ant-design/icons";

interface ListTableInterface {
  className?: string;
  limit: number;
}

const _ListTable = ({ className, limit }: ListTableInterface) => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => state.watcher.bundles.ids);
  const bundles = useAppSelector(state => state.watcher.bundles.entities);
  const count = useAppSelector(state => state.watcher.bundles.count);
  const { write_bundles } = usePermissions();
  const data  = ids ? ids.map(id => bundles[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  const renderPlatformIcon = (platform: string) => {
    if (platform === 'ios') {
      return <AppleOutlined />
    } else {
      return <AndroidOutlined />
    }
  }

  const renderForceUpdate = (force_update: boolean) => {
    if (force_update) {
      return <Tag color="orange">true</Tag>
    } else {
      return <Tag color="blue">false</Tag>
    }
  }

  const columns: ColumnsType<BundleInterface> = [
    {
      key: 'icon_url',
      title: '',
      dataIndex: 'icon_url',
      render: (_, { icon_url, platform }) => {
        return <Avatar
          src={icon_url}
          alt='Bundle icon'
          size={32}
          icon={renderPlatformIcon(platform)}
          shape='square'
        />
      },
      width: 50
    },

    {
      key: 'name',
      title: 'Name',
      render: (_, { name, platform, url }) => <OptionalLink link={url}>{renderPlatformIcon(platform)} {name}</OptionalLink>,
      width: 135,
      ellipsis: true
    },

    {
      key: 'version',
      title: 'Version',
      render: (_, { version }) => <small>{version}</small>,
      width: 125
    },

    {
      key: 'force_update',
      title: 'Force Update',
      render: (_, { force_update }) => renderForceUpdate(force_update),
      width: 125
    },

    {
      key: 'created_at',
      title: 'Created at',
      render: (_, { created_at }) => {
        return <small>{formattedDate(created_at).dateTime}</small>;
      },
      width: 125
    },

    {
      key: 'updated_at',
      title: 'Updated at',
      render: (_, { updated_at }) => {
        return <small>{formattedDate(updated_at).dateTime}</small>;
      },
      width: 125
    },

    ...(write_bundles ? [{
      key: 'action',
      title: 'Action',
      render: (_: any, { id }: BundleInterface) => {
        return (
          <Space size="middle">
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
          </Space>
        );
      },
      width: 100
    }] : []),
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />

      <Pagination className='v-mt-10' total={count} size={limit} />
    </div>
  )
}

export default _ListTable;
